import { render, staticRenderFns } from "./Paginacion.vue?vue&type=template&id=144acd7e&scoped=true"
import script from "./Paginacion.vue?vue&type=script&lang=js"
export * from "./Paginacion.vue?vue&type=script&lang=js"
import style0 from "./Paginacion.vue?vue&type=style&index=0&id=144acd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144acd7e",
  null
  
)

export default component.exports